var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"skip-to-content",attrs:{"href":"#main-content"}},[_vm._v(" Zum Seiteninhalt ")])
}
var staticRenderFns = []

export { render, staticRenderFns }